import React, { useCallback, useEffect } from 'react'

import {
  MaintenanceHeader,
  MaintenanceDescription,
  RedboxSquare,
  MaintenanceContainer,
  TextContainer,
  TryAgainButton,
  DevContainer,
} from './RedboxInfo.styles'

interface RedboxInfoProps {
  error: Error | null
  componentStack?: string
  resetError?: () => void
}

export const RedboxInfo: React.FC<RedboxInfoProps> = ({
  error,
  componentStack,
  resetError,
}) => {
  // log the error to the console
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Error caught by boundary:', {
      error,
      componentStack,
    })
  }, [error])

  const reset = useCallback(() => {
    if (resetError) {
      resetError()
    }
    // error boundary is above router, so we need to navigate to the home page
    location.href = '/'
  }, [resetError])

  // TODO design this error page
  return (
    <div>
      <TryAgainButton onClick={reset}>Try again</TryAgainButton>
      <MaintenanceContainer>
        <RedboxSquare />
        <TextContainer>
          <MaintenanceHeader>Redbox Under Maintenance</MaintenanceHeader>
          <MaintenanceDescription>
            Redbox is currently under maintenance and will be back soon!
          </MaintenanceDescription>
        </TextContainer>
      </MaintenanceContainer>

      {/* if dev */}
      {import.meta.env.DEV && error && (
        <DevContainer>
          <p>{error.message}</p>
          <pre>{componentStack}</pre>
          <pre>{error.stack}</pre>
        </DevContainer>
      )}
    </div>
  )
}
